import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const jira = defineConnector({
  identifier: "jira",
  name: "Jira",
  tagLine: "Issue and project tracking",
  keywords: "atlassian issues tickets bugs epics tasks project tracking",
  logo,
  protocol: "http",
  tags: ["featured", "it", "productivity"],
  defaultUrlPattern: () => "https://.*\\.atlassian\\.net/rest/api/.*",
  auth: (app) =>
    basicAuth({
      username: app.config.email,
      password: app.secret.apiToken,
    }),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [this page](https://id.atlassian.com/manage-profile/security/api-tokens) signed in as the account you’d like associated with your automated Jira actions. (We recommend a service account.)\n\nClick **Create API token** and give it a label when asked.",
        },
      ],
    },
    {
      title: "Copy and paste the API token here",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
    {
      title: "Enter the account’s email address",
      items: [
        {
          kind: "input",
          label: "API token account email",
          placeholder: "you@example.com",
          required: true,
          target: { kind: "configuration", field: "email" },
        },
      ],
    },
    {
      title: "Enter your Jira account domain",
      items: [
        {
          kind: "hostname",
          label: "Jira account domain",
          placeholder: "example.atlassian.net",
          required: true,
          target: { kind: "configuration", field: "domain" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/rest/api/3/myself`,
  },
  publicEnvVars: ({ domain, email }) => ({
    JIRA_DOMAIN: domain || "",
    JIRA_EMAIL: email || "",
  }),
});
